import { usePinPodBanner } from "@app/hooks/usePinPodBanner";
import type { LightWorkspaceType } from "@app/types/user";
import { Button, Pin02 } from "@dust-tt/sparkle";
import { useLingui } from "@lingui/react/macro";

interface PinPodBannerButtonProps {
  owner: LightWorkspaceType;
  spaceId: string;
  pinnedFramePath: string | null;
  isEditor: boolean;
  framePath: string | null;
  fileName?: string;
  hidden?: boolean;
}

export function PinPodBannerButton({
  owner,
  spaceId,
  pinnedFramePath,
  isEditor,
  framePath,
  fileName,
  hidden,
}: PinPodBannerButtonProps) {
  const { t } = useLingui();
  const { togglePin, isPinned } = usePinPodBanner({
    owner,
    podId: spaceId,
    pinnedFramePath,
    isEditor,
  });

  if (hidden || !isEditor || !framePath) {
    return null;
  }

  const pinnedAsBanner = isPinned(framePath);

  return (
    <Button
      icon={Pin02}
      variant={pinnedAsBanner ? "highlight-ghost" : "ghost"}
      label={""}
      tooltip={
        pinnedAsBanner
          ? t`Unpin from workroom banner`
          : t`Pin as workroom banner`
      }
      onClick={() =>
        void togglePin(framePath, {
          fileName,
        })
      }
    />
  );
}
